<template lang='pug'>
carousel-3d(
  :autoplay="true" :autoplay-timeout="5000" :display="3")
  slide(v-for="(slide, i) in slides" :key="i")
    span you know
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d'
export default {
  components: {
    Carousel3d,
    Slide
  },
  props: {
    lstItems: Array
  },
  data() {
    return {
      slides: 7
    }
  }
}
</script>

<style lang="scss">
.carousel-3d-container figure {
  margin: 0;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 12px;
  min-width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// effectRank.vue?08f21f47